export const QUERY_FLATFILE_UPLOAD_JOB = "QUERY_FLATFILE_UPLOAD_JOB";
export const QUERY_FLATFILE_SKIPPED_ROWS_COUNT =
  "QUERY_FLATFILE_SKIPPED_ROWS_COUNT";
